<ng-template #empty>
  <div class="tw-center-600 tw-padding-10 mat-elevation-z1" style="min-height: 100px;text-align: center">
    {{ 'reservation.emptyList' | translate }}
  </div>
</ng-template>
<div class="reservation-table-container mat-elevation-z2 tw-margin-10" >
  <table mat-table
    [dataSource]="dataSource" multiTemplateDataRows
    class=" reservation-table" tabindex="0">

    <ng-container matColumnDef="detail" >
      <th mat-header-cell style="width:300px" *matHeaderCellDef>
                <div class="tw-flex tw-flex-wrap" style="    justify-content: space-between;
    align-items: center;">
          <div>
            <h2>{{ 'title.reservations' | translate }}</h2>
          </div>
          @if (false) {
            <div>
              <mat-form-field class="example-form-field" style="min-width: 300px">
                <mat-label>{{'formMsg.filter' | translate}}</mat-label>
                <mat-date-range-input
                  [formGroup]="campaignOne"
                  [rangePicker]="dateOnePicker"
                  >
                  <input matStartDate placeholder="{{'date.startDate' | translate}}" formControlName="start" [disabled]="true">
                  <input matEndDate placeholder="{{'date.endDate' | translate}}" formControlName="end" [disabled]="true">
                </mat-date-range-input>
                <mat-hint>{{getDateFormatString()}}</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="dateOnePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #dateOnePicker ></mat-date-range-picker>
              </mat-form-field>
            </div>
          }
        </div>
      </th>
      <td mat-cell *matCellDef="let element" style="width:300px">
        <div class=""  style="position: relative; margin: 15px 0" >
          <tw-client-reservation-header [reservation]="element" ></tw-client-reservation-header>
            <div style="margin-top: 10px; text-align: right; display: flex; gap: 8px; justify-content: flex-end;">
                <button mat-raised-button color="warn" (click)="releaseReservation(element)">
                    {{ 'reservation.release' | translate }}
                </button>
            <button mat-raised-button color="primary" (click)="purchaseReservation(element)">
              {{ 'cart.buyNow' | translate }}
            </button>
          </div>
          @if (false) {
            <button
                            style="    position: absolute;
    bottom: 0;
    right: 6px;"
              mat-icon-button aria-label="expand row"
              (click)="(detailCell('detail',element)); $event.stopPropagation()">
              @if (expandedElement !== element) {
                <mat-icon>keyboard_arrow_down</mat-icon>
              }
              @if (expandedElement === element) {
                <mat-icon>keyboard_arrow_up</mat-icon>
              }
            </button>
          }
        </div>

      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail" >
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div class="reservation-element-detail"
          [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
          {{element | json}}
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
      class="reservation-element-row"
      [class.reservation-expanded-row]="expandedElement === element"
      >
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="reservation-detail-row"></tr>
  </table>
  <mat-paginator
  [length]="resultsLength" [pageSize]="10" aria-label="Select page of GitHub search results"></mat-paginator>

</div>
